export default "__VITE_ASSET__L9DD8wNZ__"